






















import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import OrderAutocompleteInput from "../order/OrderAutocompleteInput.vue";
import UserAutocompleteInput from "../user/UserAutocompleteInput.vue";
import AsiDatePicker from "../common/AsiDatePicker.vue";
import AsiTextarea from "../common/AsiTextarea";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
import PlanningEntryUpdate from "@/models/planningEntry/PlanningEntryUpdate";
import OrderListEntry from "@/models/order/OrderListEntry";
import UserListEntry from "@/models/user/UserListEntry";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import {AxiosError} from "axios";
import UserListFilter from "@/models/user/UserListFilter";
import {CompanyType} from "@/helpers/constants";
import OrderListFilter from "@/models/order/OrderListFilter";
import Order from "@/models/order/Order";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import OrderSimple from "@/models/order/OrderSimple";

@Component({
	components: {AsiTextarea, AsiDatePicker, UserAutocompleteInput, OrderAutocompleteInput, AsiDialogFormLayout}
})
export default class PlanningEntryUpdateDialog extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public planningEntry!: PlanningEntryListEntry;

	@Prop({type: Boolean, default: false})
	public fixedOrder!: boolean;

	private model: PlanningEntryUpdate | null = null;
	private loadingOrder: boolean = false;
	private selectedOrder: Order | null = null;
	private minDate: string | null = null;
	private maxDate: string | null = null;

	private get orderListFilter(): OrderListFilter {
		const filter = new OrderListFilter();
		filter.includeIds = [this.planningEntry.order.id];
		return filter;
	}

	private get userListFilter(): UserListFilter {
		const filter = new UserListFilter();
		if (this.planningEntry.user !== null) {
			filter.includeIds = [this.planningEntry.user.id];
		}
		filter.companyTypes = [CompanyType.internal];
		return filter;
	}

	public created(): void {
		this.loadSelectedOrder();
	}

	public mounted(): void {
		this.setPlanningEntryInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setPlanningEntryInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('model.orderId')
	private onModelOrderIdChanged(): void {
		this.loadSelectedOrder();
	}

	private loadSelectedOrder(): void {
		if (this.model === null || this.model.orderId === null) {
			this.selectedOrder = null;
			this.minDate = null;
			this.maxDate = null;
			return;
		}

		this.loadingOrder = true;
		this.$orderService.order(this.model.orderId)
			.then(order => {
				this.selectedOrder = order;
				this.minDate = order.dateFrom;
				this.maxDate = order.dateTo;

				if (this.model !== null && this.model.date !== null && !OrderSimple.isDateWithinRange(order, this.model.date)) {
					this.model.date = null;
				}
			})
			.catch(() => {
				this.minDate = null;
				this.maxDate = null;

				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => this.loadingOrder = false);
	}

	private orderChanged(order: OrderListEntry): void {
		if (this.model === null) return;
		this.model.orderId = order.id;
	}

	private userChanged(user: UserListEntry | null): void {
		if (this.model === null || user === null) return;
		this.model.userId = user.id;
	}

	@Watch('planningEntry', {deep: true})
	private onPlanningEntryChanged(): void {
		this.setPlanningEntryInternal();
	}

	private setPlanningEntryInternal(): void {
		if (this.model === null) {
			this.model = new PlanningEntryUpdate(this.planningEntry);
		} else {
			this.model.setDetailModel(this.planningEntry);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$planningEntryService.update(this.planningEntry.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
